import type { SavedDocument } from '../types';

const STORAGE_KEY = 'generatedDocuments';

export const getGeneratedDocuments = (): SavedDocument[] => {
  try {
    const savedDocs = localStorage.getItem(STORAGE_KEY);
    return savedDocs ? JSON.parse(savedDocs) : [];
  } catch (error) {
    console.error("Failed to parse documents from localStorage", error);
    return [];
  }
};

export const saveGeneratedDocument = (document: Omit<SavedDocument, 'id' | 'createdAt'>): void => {
  const documents = getGeneratedDocuments();
  const newDocument: SavedDocument = {
    ...document,
    id: new Date().getTime().toString(), // Simple unique ID
    createdAt: new Date().toISOString(),
  };
  documents.unshift(newDocument); // Add to the beginning of the list
  localStorage.setItem(STORAGE_KEY, JSON.stringify(documents));
};

export const updateGeneratedDocument = (docId: string, newContent: string): void => {
  const documents = getGeneratedDocuments();
  const docIndex = documents.findIndex(doc => doc.id === docId);
  if (docIndex !== -1) {
    documents[docIndex].content = newContent;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(documents));
  }
};

export const deleteGeneratedDocument = (docId: string): void => {
  let documents = getGeneratedDocuments();
  documents = documents.filter(doc => doc.id !== docId);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(documents));
};